export const OPS_CHAT_FILE_ACCEPT = [
  ".pdf", ".docx", ".pptx", ".xlsx", ".csv", ".txt", ".md", ".html", ".json",
  ".jpg", ".jpeg", ".png", ".webp", ".gif",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv", "text/plain", "text/markdown", "application/json",
  "image/jpeg", "image/png", "image/webp", "image/gif"
].join(",");

const MAX_OPS_CHAT_FILE_BYTES = 32 * 1024 * 1024;
const ALLOWED_EXTENSIONS = new Set([
  "pdf", "docx", "pptx", "xlsx", "csv", "txt", "md", "html", "json",
  "jpg", "jpeg", "png", "webp", "gif"
]);

export function validateOpsChatFileSelection(file: Pick<File, "name" | "size" | "type">): string | null {
  if (!Number.isInteger(file.size) || file.size < 1 || file.size > MAX_OPS_CHAT_FILE_BYTES) {
    return "Choose a non-empty file no larger than 32 MB.";
  }
  const extension = /[.]([^.]+)$/u.exec(file.name.trim())?.[1]?.toLowerCase() ?? "";
  if (!ALLOWED_EXTENSIONS.has(extension)) {
    return "Choose a common document, spreadsheet, PDF, or image file.";
  }
  return null;
}
